import React from "react";
import MainCard from "./MainCard";
import styles from "./CardsPanel.module.css";


import {
  FaWallet,
  FaBalanceScale,
  FaFileAlt,
  FaTools,
  FaUserFriends,
  FaClock
} from "react-icons/fa";

export default function CardsPanel({
  userData,
  selectedCard,
  setSelectedCard,
  navigate
}) {
  const cards = [
    {
      id: "assets",
      title: "Assets",
      icon: <FaWallet />,
      gradient: "linear-gradient(135deg,#4A90E2,#357ABD)",
      summary: `${Object.keys(userData.assets || {}).length} categories`
    },
    {
      id: "liabilities",
      title: "Liabilities",
      icon: <FaBalanceScale />,
      gradient: "linear-gradient(135deg,#E94E77,#D43F5A)",
      summary: `${Object.keys(userData.liabilities || {}).length} categories`
    },
    {
      id: "infoDocs",
      title: "Info & Docs",
      icon: <FaFileAlt />,
      gradient: "linear-gradient(135deg,#F5A623,#F7C16C)",
      summary: `${userData.infoDocs?.messages?.length || 0} messages, ${
        userData.infoDocs?.documents?.length || 0
      } docs`
    },
    {
      id: "maintenance",
      title: "Maintenance",
      icon: <FaTools />,
      gradient: "linear-gradient(135deg,#9B59B6,#8E44AD)",
      summary: `${Object.keys(userData.maintenance || {}).length} policies`
    },
    {
      id: "trustedContacts",
      title: "Trusted Contacts",
      icon: <FaUserFriends />,
      gradient: "linear-gradient(135deg,#1ABC9C,#16A085)",
      summary: `${userData.trustedContacts?.length || 0} contacts`
    },
    {
      id: "inactivitySettings",
      title: "Inactivity Settings",
      icon: <FaClock />,
      gradient: "linear-gradient(135deg,#7F8C8D,#95A5A6)",
      summary: `${userData.inactivitySettings?.inactivityPeriodMonths || 0} months, ${
        userData.inactivitySettings?.reminderDays || 0
      } days reminder`
    }
  ];

  return (
    <div className={styles.cardsColumn}>
      <div className={styles.cardsGrid}>
        {cards.map((card) => (
          <MainCard
			  key={card.id}
			  card={card}
			  className={card.id}   // ← this is valid
			  isSelected={selectedCard === card.id}
			  onClick={() => navigate(`/category/${card.id}`)}
			/>

        ))}
      </div>

      {selectedCard && (
        <div className={styles.expandedSection}>
          <h2>{cards.find((c) => c.id === selectedCard).title}</h2>
          <p>
            Here you will see details for{" "}
            {cards.find((c) => c.id === selectedCard).title}.
          </p>
        </div>
      )}
    </div>
  );
}
